import * as yup from 'yup'

export const changeUserGroupValidationSchema = yup.object().shape({
    group_id: yup.string().nullable()
})

